import React from "react";

const SimpleTextArea = ({
  label,
  value,
  onChange,
  placeHolder,
  className = "",
  maxLength = 500,
  isDisabled = false,
  name,
  isSmall = false,
}) => {
  return (
    <div className="w-100">
      {label && (
        <label className="field-label" htmlFor={name}>
          {label}
        </label>
      )}

      <div
        className={
          isSmall
            ? `input-field-wrapper input-textarea-wrapper-6em`
            : `input-field-wrapper input-textarea-wrapper`
        }
      >
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeHolder}
          maxLength={maxLength}
          disabled={isDisabled}
          className={
            isSmall
              ? `input-textfield input-textarea-field-6em input-textfield-without-icon ${className}`
              : `input-textfield input-textarea-field input-textfield-without-icon ${className}`
          }
          style={{ height: "100%", width: "100%", resize: "none" }}
        />
      </div>
    </div>
  );
};

export default SimpleTextArea;
